import { usePrimaryPage } from '@/PageManager'
import { checkLogin } from '@/atoms/session'
import { useAtomValue } from 'jotai'
import { filteredNewNotificationsAtom } from '@/atoms/notifications'
import { hideNotificationsAtom } from '@/atoms/preferences'
import { HugeiconsIcon } from '@hugeicons/react'
import { BellIcon } from '@hugeicons/core-free-icons'
import SidebarItem from './SidebarItem'

export default function NotificationsButton({ collapse }: { collapse: boolean }) {
  const { navigate, current, display } = usePrimaryPage()
  const hasNewNotification = useAtomValue(filteredNewNotificationsAtom) > 0
  const hideNotifications = useAtomValue(hideNotificationsAtom)
  if (hideNotifications) return null

  return (
    <SidebarItem
      title="Notifications"
      onClick={() => checkLogin(() => navigate('notifications'))}
      active={display && current === 'notifications'}
      collapse={collapse}
    >
      <div className="relative">
        <HugeiconsIcon icon={BellIcon} />
        {hasNewNotification && (
          <div className="absolute -top-1 right-0 w-2 h-2 ring-2 ring-background bg-primary rounded-full" />
        )}
      </div>
    </SidebarItem>
  )
}
